export default __webpack_public_path__ + "static/media/np.5c2a69a9.svg";